import React from 'react';
import { Row, Col, Breadcrumb } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Link, useLocation } from 'react-router-dom';

import { GeneralInformation, Frequency, Posture, WorkCondition, WorkOrganization, Result } from './Report/Steps';
import { breadcrumbNameMap } from '@/components/Layout/Breadcrumb/constants';
import { KimLhcProvider, useKimLhc } from '@/context/KimLhc';
import { StepComponent } from './Step';

import { Steps } from '@/context/KimLhc/types';

const steps: Steps[] = [
	{
		id: '1',
		name: I18n.get('General Information'),
		sequence: 1,
		description: I18n.get('General Information'),
		component: <GeneralInformation />
	},
	{
		id: '2',
		name: I18n.get('Frequency and load'),
		sequence: 2,
		description: I18n.get('Frequency and load'),
		component: <Frequency />
	},
	{
		id: '3',
		name: I18n.get('Posture'),
		sequence: 3,
		description: I18n.get('Posture'),
		component: <Posture />
	},
	{
		id: '4',
		name: I18n.get('Work Condition'),
		sequence: 4,
		description: I18n.get('Condições de trabalho'),
		component: <WorkCondition />
	},
	{
		id: '5',
		name: I18n.get('Work Organization'),
		sequence: 5,
		description: I18n.get('Work organization'),
		component: <WorkOrganization />
	},
	{
		id: '6',
		name: I18n.get('Result'),
		sequence: 6,
		description: I18n.get('Result'),
		component: <Result />
	}
];

function KimLhcWithBreadcrumb(): JSX.Element {
	const location = useLocation();
	const { currentStep } = useKimLhc();

	const pathSnippets = location.pathname.split('/').filter((i) => i);
	const breadcrumbItems = pathSnippets
		.map((_, index) => {
			const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
			const name = breadcrumbNameMap[url as keyof typeof breadcrumbNameMap];
			if (!name) return null;

			const linkTo = url === '/reporting/kim-lhc' ? '/reporting' : url;
			return (
				<Breadcrumb.Item key={url}>
					<Link to={linkTo}>{I18n.get(name)}</Link>
				</Breadcrumb.Item>
			)
		})
		.filter(Boolean);

	if (steps[currentStep]?.name) {
		breadcrumbItems.push(
			<Breadcrumb.Item key="step">
				{I18n.get(steps[currentStep].name)}
			</Breadcrumb.Item>
		);
	}

	return (
		<>
			<Breadcrumb style={{ marginBottom: '16px' }}>
				<Breadcrumb.Item>
					<Link to="/">{I18n.get('Home')}</Link>
				</Breadcrumb.Item>
				{breadcrumbItems}
			</Breadcrumb>
			<Row>
				<Col span={24}>
					<StepComponent steps={steps} />
				</Col>
			</Row>
		</>
	);
}

export function KimLhc(): JSX.Element {
	return (
		<KimLhcProvider>
			<KimLhcWithBreadcrumb />
		</KimLhcProvider>
	);
}